export const PARAMS = {
	ID: ':id',
	OBJECT_ID: ':objectId',
	TOKEN: ':token'
};
